import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import Loader from "@/components/site/Loader";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import ServiceDetail from "@/pages/ServiceDetail";
import Progetti from "@/pages/Progetti";
import Contatti from "@/pages/Contatti";
import ContoTermico from "@/pages/ContoTermico";
import Certificazioni from "@/pages/Certificazioni";
import Squadra from "@/pages/Squadra";
import Preventivo from "@/pages/Preventivo";
import ComputoCanali from "@/pages/ComputoCanali";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function SmoothScroll() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);
    return null;
}

export default function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <SmoothScroll />
                <ScrollToTop />
                <Loader />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/servizi" element={<Servizi />} />
                        <Route path="/servizi/:slug" element={<ServiceDetail />} />
                        <Route path="/progetti" element={<Progetti />} />
                        <Route path="/conto-termico" element={<ContoTermico />} />
                        <Route path="/certificazioni" element={<Certificazioni />} />
                        <Route path="/squadra" element={<Squadra />} />
                        <Route path="/preventivo" element={<Preventivo />} />
                        <Route path="/tecnico/computo-canali" element={<ComputoCanali />} />
                        <Route path="/contatti" element={<Contatti />} />
                    </Routes>
                </main>
                <Footer />
                <WhatsAppButton />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </LanguageProvider>
    );
}
